module.exports = __webpack_public_path__ + "static/social-interactions-2-d140370978c8f204f75f0576831f1ee5.jpg";